export default __webpack_public_path__ + "static/media/pokedex-icon.388c5f3e.jpg";